import React, { useState,useEffect } from 'react';
import { useTranslation } from 'react-i18next';



const LimitDay = ({ AuthService, UserService }) => {

   const { t } = useTranslation();

   
   const [isLimitEnabled, setIsLimitEnabled] = useState(false);
   const [limitValue, setLimitValue] = useState(0);


   useEffect(() => {
      const fetchUserLimit = async () => {
          const userId = AuthService.getCustom("user_id");
          if (userId) {
              const userLimitData = await UserService.getUserLimit(userId);
             
              if (userLimitData.response.limit_deposit_status && userLimitData.response.limit_deposit_status == "1") {
                  setIsLimitEnabled(userLimitData.response.limit_deposit_status || 0); 
                  setLimitValue(userLimitData.response.limit_deposit_value || 0); 
              }
          }
      };

      fetchUserLimit();
  }, [AuthService, UserService]);

  const handleLimitToggle = (event) => {
   const newLimitStatus = event.target.checked;
   setIsLimitEnabled(newLimitStatus);
   updateLimit(newLimitStatus, limitValue);
};


const handleLimitChange = (event) => {
   const newValue = event.target.value;
   setLimitValue(newValue);
   updateLimit(isLimitEnabled, newValue); 
};

const updateLimit = async (limitStatus, limitValue) => {
   const userId = AuthService.getCustom("user_id");
   await UserService.updateUserLimit(userId, limitStatus ? "1" : "0", limitValue);
};


  return (

    <div className="form-online">
    <section className="forms boxed-form">
       <div className="form signup">
          <div className="form-content">
             
                <h3 className="accordion-button collapsed"   data-bs-toggle="collapse" data-bs-target="#money-limit">

                <svg
                    id="Livello_1"

                    xmlns="http://www.w3.org/2000/svg"
                    xmlnsXlink="http://www.w3.org/1999/xlink"
                    x="0px"
                    y="0px"
                    viewBox="0 0 283.46 283.46"
                    style={{
                    enableBackground: "new 0 0 283.46 283.46",
                    }}
                    xmlSpace="preserve"
                   
                >
                    <path d="M2.86,141.54C2.84,65.21,64.57,3.42,140.85,3.41c76.37,0,138.12,61.72,138.06,138.01c-0.06,76.4-61.73,138.04-138.06,138.02 C64.67,279.41,2.88,217.66,2.86,141.54z M53.55,47.82c0.69,0.46,1.47,0.83,2.04,1.4c7.79,7.75,15.56,15.53,23.32,23.32 c2.48,2.49,2.7,5.57,0.61,7.58c-2.12,2.04-4.92,1.82-7.39-0.64c-4.54-4.51-9.06-9.03-13.55-13.6c-3.84-3.9-7.61-7.86-11.42-11.8 C2.48,100.8-2.05,181.84,52.01,233.85c54.11,52.05,133.11,43.28,176.02,1.44c-2.61-2.58-5.24-5.14-7.84-7.73 c-5.75-5.73-11.52-11.45-17.23-17.23c-2.83-2.87-1.94-7.28,1.63-8.34c2.19-0.65,3.95,0.16,5.53,1.76 c7.63,7.69,15.3,15.33,22.96,22.98c0.61,0.61,1.26,1.18,1.89,1.77c46.13-48.8,47.78-131.37-7.74-181.94 C172.83-3,95.4,6.66,53.55,47.82z" />
                    <path d="M55.34,141.21c0-4.84,0.16-9.69-0.03-14.52c-0.44-10.88,3.78-19.79,11.27-27.35c8.57-8.64,19.04-14.25,30.48-17.86 c32.33-10.21,64.42-9.7,95.99,3.22c9.35,3.82,17.71,9.3,24.4,17.02c6.03,6.95,9.25,14.92,9.09,24.27c-0.18,10-0.26,20.02,0.02,30.02 c0.32,11.37-4.11,20.55-12.09,28.25c-9.37,9.05-20.76,14.62-33.08,18.2c-28.41,8.24-56.8,8.03-84.95-1.32 c-11.32-3.76-21.7-9.3-30.15-17.95c-7.31-7.49-11.39-16.29-10.98-26.97C55.5,151.22,55.34,146.21,55.34,141.21z M139.41,164.29 c18.8,0,35.63-3.17,49.35-9.2c9.03-3.97,17.34-9,23.26-17.17c6.37-8.79,6.39-18.34,0.12-27.18c-5.08-7.16-12.1-11.94-19.84-15.72 c-12.15-5.94-25.1-8.98-38.52-10.18c-19.03-1.71-37.66,0.01-55.71,6.54c-9.34,3.38-17.99,7.98-24.99,15.2 c-10.71,11.05-10.74,24-0.15,35.15c5.28,5.56,11.66,9.54,18.58,12.67C107.18,161.51,123.75,164.12,139.41,164.29z M124.3,173.35 c-0.06,0.31-0.17,0.62-0.18,0.93c-0.01,7.22,0.02,14.44-0.05,21.66c-0.02,1.66,0.91,1.81,2.16,1.93 c10.73,1.02,21.44,0.95,32.17-0.31c2.32-0.27,2.78-1.14,2.74-3.22c-0.11-6.31-0.03-12.63-0.05-18.95c0-0.86-0.1-1.72-0.12-2.03 C148.56,173.35,136.48,173.35,124.3,173.35z M88.41,164.36c0,7.21-0.03,14.57,0.06,21.92c0.01,0.58,0.82,1.4,1.45,1.68 c3.05,1.39,6.1,2.85,9.27,3.9c4.87,1.6,9.84,2.88,15.21,4.42c0-1.46,0-2.33,0-3.21c0.01-5.9,0-11.8,0.04-17.7 c0.02-3.75,0.01-3.59-3.59-4.57C103.47,168.79,96.12,166.59,88.41,164.36z M192.34,164.57c-0.53,0.03-0.78-0.01-1,0.06 c-6.4,1.99-12.81,3.95-19.17,6.06c-0.62,0.21-1.31,1.36-1.32,2.09c-0.1,6.88-0.06,13.76-0.04,20.65c0,0.53,0.16,1.06,0.33,2.15 c5.34-1.79,10.49-3.35,15.52-5.25c5.74-2.17,5.69-2.3,5.66-8.54c-0.01-2.05,0.02-4.1,0.02-6.14 C192.34,171.96,192.34,168.29,192.34,164.57z M202.01,181.54c10.8-5.07,17.42-20.58,14.51-32.87c-4.55,3.36-9.2,6.77-13.81,10.24 c-0.38,0.29-0.67,0.97-0.67,1.46C202,167.34,202.01,174.29,202.01,181.54z M65.28,148.54c-2.32,13.06,3.6,27.6,13.11,31.99 c0.08-0.14,0.23-0.27,0.23-0.41c0.04-6.81,0.09-13.61,0.04-20.42c0-0.59-0.55-1.34-1.06-1.74 C73.54,154.79,69.43,151.69,65.28,148.54z" />
                    <path d="M146.02,140.28c-2.68-3.52-4.94-6.63-7.39-9.58c-0.46-0.55-1.7-0.59-2.59-0.61c-5.55-0.13-11.12,0.08-16.65-0.35 c-3.8-0.3-7.21-2.11-10.06-4.78c-4.91-4.6-5.4-11.07-0.78-15.97c2.37-2.52,5.44-4.38,8.45-6.73c-0.05-0.14-0.29-0.71-0.45-1.31 c-0.63-2.31,0.32-4.63,2.3-5.7c2.05-1.11,4.75-0.9,5.95,1.18c1.91,3.3,4.47,3.14,7.65,2.78c6.09-0.68,12.12-0.08,17.91,2.12 c3.37,1.28,4.74,3.82,3.67,6.68c-1,2.66-3.74,3.62-7,2.41c-3.9-1.44-7.91-1.9-12.68-1.67c2.75,3.62,5.09,6.92,7.72,9.98 c0.5,0.58,2.13,0.21,3.23,0.23c5.39,0.07,10.8-0.16,16.15,0.29c3.72,0.31,6.98,2.3,9.69,4.96c4.96,4.86,5.34,11.17,0.54,16.18 c-2.33,2.44-5.34,4.23-8.27,6.48c0.09,0.28,0.37,0.94,0.53,1.63c0.51,2.28-0.44,4.38-2.4,5.43c-1.95,1.04-4.64,0.88-5.78-1.04 c-1.88-3.16-4.28-3.34-7.58-2.99c-6.48,0.7-12.95,0.21-19.07-2.43c-2.77-1.19-3.9-3.22-3.37-5.82c0.62-3.03,3.74-4.52,6.96-3.19 C136.8,140.14,141.04,140.62,146.02,140.28z M149.23,128.35c1.65,2.2,3.02,4.02,4.38,5.83c3.6,4.77,4.26,4.86,9.16,1.28 c3.25-2.37,3.16-3.95-0.5-5.77C158.31,127.72,154.08,127.82,149.23,128.35z M131.15,120.7c-2.52-3.33-4.59-6.16-6.8-8.88 c-0.37-0.46-1.51-0.78-2.02-0.55c-1.85,0.84-3.7,1.77-5.32,2.98c-2.46,1.84-2.38,3.08,0.27,4.55 C121.44,121.11,125.97,121.1,131.15,120.7z" />
                    <path d="M149.23,128.35c4.85-0.53,9.08-0.63,13.04,1.34c3.67,1.82,3.75,3.39,0.5,5.77c-4.9,3.58-5.56,3.49-9.16-1.28 C152.25,132.37,150.89,130.55,149.23,128.35z" />
                    <path d="M131.15,120.7c-5.18,0.4-9.71,0.4-13.88-1.91c-2.64-1.47-2.73-2.71-0.27-4.55c1.62-1.21,3.47-2.14,5.32-2.98 c0.51-0.23,1.65,0.09,2.02,0.55C126.56,114.54,128.63,117.37,131.15,120.7z" />
                </svg>

                    {t('Daily_limit')}</h3>
              <form action="#" id="money-limit" className="accordion-collapse collapse">
            <div className="money-limit">

             <label className="particles-checkbox-container day-limit">
             <input
                                        type="checkbox"
                                        checked={isLimitEnabled}
                                        className="particles-checkbox"
                                        name="toggle"
                                        onChange={handleLimitToggle}
                                    />
             <span>{t('Active_daily_limit')}</span>
                
             </label>
       
            {isLimitEnabled && (
                 <div className="input-group">
                                 <input
                                 type="number"
                                 className="form-control"
                                 placeholder={`${t('Enter_daily_limit')}...`}
                                 aria-label="Username"
                                 aria-describedby="basic-addon1"
                                 value={limitValue}
                                 onChange={handleLimitChange}
                              />

                     <span className="input-group-text" id="basic-addon1">
                                    R$
                                 </span>
                     </div>
            )}
                              
        
         
         </div>

             </form>
          </div>
       </div>
    </section>
 </div>


  );
};

export default LimitDay;
